import React, { useState, useContext,useEffect } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";

import { AppContext } from "../../AppContext";

import { isJwCole } from "../../common/checkClient"

import PopupMenuComp from "./PopupMenuComp";
import UserPopupMenuComp from "./UserPopupMenuComp";
import NotificationComp from "./NotificationComp";

const HeaderComp = (props) => {

    const [appContext, setAppContext] = useContext(AppContext);
    const jwCole = isJwCole();

    const history = useHistory();
    const [showingPopupMenu, setShowingPopupMenu] = useState(false);
    const [showingUserPopupMenu, setShowingUserPopupMenu] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [notificationCount, setNotificationCount] = useState(appContext.notificationCount);


    let env = "PRODUCTION";
    if (appContext.appFeature && appContext.appFeature.DEPLOYMENT_ENVIRONMENT) {
        env = appContext.appFeature.DEPLOYMENT_ENVIRONMENT;
    }

    const bannerClass = env === 'PRODUCTION' ? '' : env === 'STAGING' ? 'bg-orange' : '';
    const headerClass = `header-wrapper ${bannerClass} no-print`;

    const deployment = env === 'PRODUCTION' ? '' : env === 'STAGING' ? ' - Sandbox' : '';

    const appTitle = `Risk & Compliance Intelligence (RCI) Employee Portal ${deployment}`;
   

    const handleMenuClicked = (url) => {
        setShowingPopupMenu(false);
        history.push(url);
    };

    const handlePopupMenuClose = () => {
        setShowingPopupMenu(false);
    };

    const handleUserMenuClicked = (url) => {
        setShowingUserPopupMenu(false);
        history.push(url);
    };

    const handleUserPopupMenuClose = () => {
        setShowingUserPopupMenu(false);
    };

    const handleNotificationClose = ()=>{
      setShowNotifications(false);
    }

    useEffect(() => {
      setNotificationCount(appContext.notificationCount)
    }, [appContext.notificationCount]);

    return (
        <header className={headerClass}>
            <div className="header">
                <div className="header-left">
                    <div className="icon-container">
                        {appContext.auth &&
                            <div className="icon-sidebar-menu" onClick={props.toggleSidebar}>
                                <img className="icon" src="img/icon/sidebar_menu.svg" alt="icon header" />
                            </div>
                        }
                    </div>
                    <div className="site-logo">
                        {
                            jwCole ? <img src="img/jwcoleLogo.png" alt="icon header" className="bg-white pl-1em pr-1em" /> : <img src="img/logo.png" alt="icon header" />
                        }
                    </div>
                    <div className="header-title">{appTitle}</div>
                </div>
                <div className="header-right">
                    {appContext.auth && (
                        <div className="nav-wrapper">
                            <nav className="nav-header">
                                <div className="topnav-collapsed" onClick={() => { setShowingUserPopupMenu((p) => !p); }}>
                                    <img className="icon" src="img/icon/user.svg" alt="icon header" />
                                </div>


                                <ul className="nav topnav-expanded">
                                    {/* <li>
                  <NavLink activeClassName="nav-selected" to="/pretrade">
                    Pre-Trade Request
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="nav-selected" to="/oba">
                    OBA
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="nav-selected" to="/political">
                    Political Contribution
                  </NavLink>
                </li>
                <li>
                  <NavLink activeClassName="nav-selected" to="/gift">
                    Gifts and Entertainments
                  </NavLink>
                </li> 

                <li> //hide for now
                  <a href="#">Multi level menu</a>
                  <ul>
                    <li>
                      <a href="#">item a lonng submenu</a>
                    </li>
                    <li>
                      <a href="#">item</a>
                      <ul>
                        <li>
                          <a href="#">Ray</a>
                        </li>
                        <li>
                          <a href="#">Veronica</a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="#">item</a>
                    </li>
                  </ul>
                </li> */}

                                    <li>
                                        <NavLink activeClassName="nav-selected" to="/profile">
                                            <img
                                                className="icon-mid mr-3"
                                                src="img/icon/user.svg"
                                                alt="icon header"
                                            />
                                            {appContext.user.userName}
                                        </NavLink>
                                        <ul>
                                            <li>
                                                <Link to="/profile">User Profile</Link>
                                            </li>
                                            <li>
                                                <Link to="/logout">Logout</Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>


                                <div className="topnav-collapsed" onClick={() => { setShowingPopupMenu((p) => !p); }}>
                                    <img className="icon" src="img/icon/menu.svg" alt="icon header" />
                                </div>

                                {/* <div className="topnav-collapsed">
                <Link to="/pretrade" className="icon">
                  <img src="img/icon/menu.svg" alt="icon pretrade" />
                </Link>
              </div> */}
                                <div className="icon-container">
                                    <div className="icon-sidebar-menu" onClick={() => { setShowNotifications((p) => !p); }}>
                                        <img className="icon" src="img/icon/bell.svg" alt="icon header" />
                                        {notificationCount>0 && 
                                          <span className="notification-count">{notificationCount}</span>
                                        }
                                    </div>
                                </div>
                            </nav>
                        </div>

                    )}
                </div>
            </div>

            {showingPopupMenu && (
                <PopupMenuComp
                    handleClose={handlePopupMenuClose}
                    handleMenuClick={handleMenuClicked}
                />
            )}
            {showingUserPopupMenu && (
                <UserPopupMenuComp
                    handleClose={handleUserPopupMenuClose}
                    handleMenuClick={handleUserMenuClicked}
                />
            )}
            {showNotifications && <NotificationComp handleClose={handleNotificationClose} /> }
        </header>
    );
};

export default HeaderComp;
